/**
 * Note that this isn't comprehensive. But removes any tags.
 * Use for metadata lines, primarily.
 */
export default function stripHtml(i) {
  return i.replace(/<(.|\n)*?>/g, '');
}

/**
 * Removes tags, adding spaces where they used to be and then removing any consecutive spaces
 * primarily used for a comment/highlight preview where only the first few words are visible
 */
function stripHtmlWithSpaces(i) {
  return i.replace(/<(.|\n)*?>/g, ' ').replace(/\s\s+/g, ' ');
}

/**
 *  Replaces newlines with a space. Removes html tags. Then collapses more than one space in a row into a single space.
 */
function stripHtmlNewlinesExtraSpaces(i) {
  return i
    .replace(/(\r\n|\n|\r)/g, ' ')
    .replace(/<(.|\n)*?>/g, ' ')
    .replace(/\s+/g, ' ');
}

export {stripHtml, stripHtmlWithSpaces, stripHtmlNewlinesExtraSpaces};
